import AdminConfigTractorBooms from './AdminConfigTractorBooms';
export default AdminConfigTractorBooms;
